<template>
  <div class="app">
    <header class="clearfix" v-cloak>
        <img src="//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/h1.jpg" alt=""/>
        <img src="//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/h2.jpg" alt=""/>
        <img src="//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/h3.jpg" alt=""/>
    </header>
    <section class="card-box">
        <participate :cardActivityNo="cardActivityNo"></participate>
        <Carddisplay 
                  :carddata="carddata"
                  :carno="carno"
                  :hchengka="hchengka"
                  :synthesis="synthesis"
                  :activityTimes="activityTimes"
                  :cardnolist="cardnolist"
                  :juanlink="juanlink"
                  :yifenlink="yifenlink"
                  :jinliif="jinliif"
                  :jinlilink="jinlilink"
        ></Carddisplay>
        <speed :ifylxd="ifylxd"></speed>
        <strategy :ifylxd="ifylxd"></strategy>
        <rules></rules>
    </section>
    <kalayer v-if="kabox" :ifprizekapiandata="ifprizekapiandata"
    :prizekapiandata="prizekapiandata"
    :hchengkadaka="hchengkadaka"
    :jinlilink="jinlilink"
    :yifenlink="yifenlink"
    ></kalayer>
    <rewardlayer v-if="awardbox" :jianglianj="jianglianj" 
                                 :jiangliadata="jiangliadata" 
                                 :saletanpgno="saletanpgno" 
                                 :juanlink="juanlink"
    ></rewardlayer>
  </div>
</template>

<script>
import * as url from '../../assets/js/url';
import participate from '../common/participate';
import rules from '../common/rules';
import strategy from '../common/strategy';
import speed from '../common/speed';
import Carddisplay from '../common/Carddisplay'
import kalayer from '../common/kalayer'
import rewardlayer from '../common/rewardlayer'


export default {
    data () {
      return {
        alertState:false,
        alertData:'',
        minAlertState:false,//小程序弹框状态
        test:'',
        parnum:'200',
        cardnolistarr:{
            ule:{
                "cd_99":{totalNums:0,ifget:1,inde:1,taget:-1,hcif:true},//邮
                "cd_100":{totalNums:0,ifget:1,inde:2,taget:-1,hcif:true},// 	乐
                "cd_101":{totalNums:0,ifget:1,inde:3,taget:-1,hcif:true},// 爽
                "cd_102":{totalNums:0,ifget:1,inde:4,taget:-1,hcif:true},// 	12
                "cd_103":{totalNums:0,ifget:1,inde:5,taget:-1,hcif:true}, // 品
                "cd_104":{totalNums:0,ifget:1,inde:6,taget:-1,hcif:true},// 	牌
                "cd_105":{totalNums:0,ifget:1,inde:7,taget:-1,hcif:true},// 	盛
                "cd_106":{totalNums:0,ifget:1,inde:8,taget:-1,hcif:true},// 	点
                "cd_107":{totalNums:0,ifget:1,inde:9,taget:-1,hcif:true}, // 狂
                "cd_108":{totalNums:0,ifget:1,inde:10,taget:-1,hcif:true},// 欢
                "cd_109":{totalNums:0,ifget:1,inde:11,taget:-1,hcif:true},// 有
                "cd_110":{totalNums:0,ifget:1,inde:12,taget:-1,hcif:true},// 你
                "cd_97":{totalNums:0,ifget:1,inde:13,taget:-1,hcif:true},//万能卡
                "cd_96":{totalNums:0,ifget:1,inde:15,taget:-1,hcif:true},//合成卡
                "cd_98":{totalNums:0,ifget:1,inde:14,taget:-1,hcif:true},//锦鲤卡
            },
            ylxd:{
                "cd_84":{totalNums:0,ifget:1,inde:1,taget:-1,hcif:true},//邮
                "cd_85":{totalNums:0,ifget:1,inde:2,taget:-1,hcif:true},// 	乐
                "cd_86":{totalNums:0,ifget:1,inde:3,taget:-1,hcif:true},// 	爽
                "cd_87":{totalNums:0,ifget:1,inde:4,taget:-1,hcif:true},// 	12
                "cd_88":{totalNums:0,ifget:1,inde:5,taget:-1,hcif:true}, // 	     品
                "cd_89":{totalNums:0,ifget:1,inde:6,taget:-1,hcif:true},// 	牌
                "cd_90":{totalNums:0,ifget:1,inde:7,taget:-1,hcif:true},// 	盛
                "cd_91":{totalNums:0,ifget:1,inde:8,taget:-1,hcif:true},// 	点
                "cd_92":{totalNums:0,ifget:1,inde:9,taget:-1,hcif:true}, // 	狂
                "cd_93":{totalNums:0,ifget:1,inde:10,taget:-1,hcif:true},// 	欢
                "cd_94":{totalNums:0,ifget:1,inde:11,taget:-1,hcif:true},// 	有
                "cd_95":{totalNums:0,ifget:1,inde:12,taget:-1,hcif:true},// 你
                "cd_81":{totalNums:0,ifget:1,inde:13,taget:-1,hcif:true},//万能卡
                "cd_83":{totalNums:0,ifget:1,inde:15,taget:-1,hcif:true},//合成卡
                "cd_82":{totalNums:0,ifget:1,inde:14,taget:-1,hcif:true},//锦鲤卡
            }
        },//卡片批次号
        cardnolist:{},
        hcehngcadarr:{
                   ule:'cd_96',
                   ylxd:'cd_83'
                },//h合成卡卡号
        hcehngcad:'cd_96',//h合成卡卡号
        jinlikas:{
            ule:'cd_98',
            ylxd:'cd_82'
        },
        jinlika:'cd_98',
        yifenlinks:{
                    ule:'//www.ule.com/event/tmpl/ulewap.html?actId=728',
                    ylxd:'//www.ule.com/event/tmpl/uxdwap.html?actId=677'
                },
        yifenlink:'//www.ule.com/event/tmpl/ulewap.html?actId=728',
        jinlilinks:{
                    ule:'//www.ule.com/event/tmpl/ulewap.html?actId=729',
                    ylxd:'//www.ule.com/event/tmpl/uxdwap.html?actId=678'
                },
        jinlilink:'//www.ule.com/event/tmpl/ulewap.html?actId=729',
        cardActivityarr:{
            ule:'CARD_1575014691366',
            ylxd:'CARD_1574405599402'
        },
        cardActivityNo:'CARD_1575014691366',//集卡活动code默认大网
        ifylxd:false,          
        activityCodearr:{
            ule:'MA_U_157501599848684',
            ylxd:'MA_U_157440534042376'
        },
        activityCode:'MA_U_157501599848684',//领卡code默认大网
        activityTimes:0,// 抽卡次数
        synthesis:false,////是否可以合成  
        ruleCode:'',//合成卡片活动规则  
        hchengka:false,//卡中是否有合成卡
        carddata:{},//大卡数据     
        carno:false,//用户是否是没有卡   
        juanlink:'',//卷列表链接 
        kabox:false,//卡片弹框判断
        ifprizekapiandata:false,//是否抽到祝福卡
        prizekapiandata:{},//抽卡时数据
        hchengkadaka:false,//是否是抽合成卡
        firstClickTimes:"",//控制连点出发抽卡事件
        jianglianj:false,//判断是否是奖励金
        swiactiveIndex:'0',//轮播图下标
        jiangliadata:{},//奖励数据
        awardbox:false,//奖励弹框显示
        jinliif:false,//是否有锦鲤卡
        saletanpgno:false,//是否有奖
      }
    },
    created(){
      var m=this;
        if(this.BASE.$browser().ylxd){
          let script = document.createElement("script");
          script.type = "text/javascript";
          script.src = "//i0.ulecdn.com/app/yxd/j/yl/dsbridge.js";
          document.getElementsByTagName("head")[0].appendChild(script);
          m.ifylxd=true;
          this.cardnolist=this.cardnolistarr.ylxd;
          this.hcehngcad=this.hcehngcadarr.ylxd;
          this.yifenlink=this.yifenlinks.ylxd;
          this.jinlilink=this.jinlilinks.ylxd;
          this.cardActivityNo=this.cardActivityarr.ylxd;
          this.activityCode=this.activityCodearr.ylxd;
          this.jinlika=this.jinlikas.ylxd;
        }else{
          this.cardnolist=this.cardnolistarr.ule;
        }
        JEND.getStatus.isLogin(function () {
                m.takeBoxfun();
                m.cardsnum();
                m.userCardfun();
        })
        // m.takeBoxfun();
        // m.cardsnum();
        // m.userCardfun();
         this.juanlink=m.getMyCouponUrl();
               
    },
    methods:{
      takeBoxfun(){//查询用户抽卡次数
        var m=this;
        this.HTTP.takeBoxs(m.activityCode).then((res) => {
            if(res.body.code=='0000'){
              m.activityTimes=res.body.content[0].times||0;
            }
        }, (err) => {
            console.log(err);
        });
      },
      cardsnum(){//获取用户卡片数量是否合成
        var m=this,taget=0;
        this.HTTP.cardsnumhttp(m.cardActivityNo).then((res) => {
           if(res.body.code=='0000'){
                                var cardInfos=res.body.content.cardInfos,hcif=false;
                                for(var i=0;i<cardInfos.length;i++){
                                    if(cardInfos[i].totalNums>0){
                                        m.cardnolist[cardInfos[i].cardNo].totalNums=cardInfos[i].totalNums;
                                        m.cardnolist[cardInfos[i].cardNo].ifget='2';
                                        m.cardnolist[cardInfos[i].cardNo].status="";
                                        m.cardnolist[cardInfos[i].cardNo].taget=taget;
                                        taget += cardInfos[i].totalNums;
                                        if(cardInfos[i].cardNo==m.hcehngcad&&cardInfos[i].totalNums>0){
                                            hcif=true;
                                            m.hchengka=true;
                                        }
                                        if(cardInfos[i].cardNo==m.jinlika){
                                            m.jinliif=true;
                                        }
                                    }else{
                                        m.cardnolist[cardInfos[i].cardNo].totalNums=cardInfos[i].totalNums;
                                        m.cardnolist[cardInfos[i].cardNo].ifget='1';
                                        m.cardnolist[cardInfos[i].cardNo].status="over";
                                        m.cardnolist[cardInfos[i].cardNo].taget=taget;
                                        taget += cardInfos[i].totalNums;
                                    }

                                }
                                if(res.body.content.combineChances[0].combineFlag==1){
                                    m.synthesis=true;
                                }
                                m.ruleCode=res.body.content.combineChances[0].ruleCode;
                                console.log(hcif);
                                m.cardnolist[m.hcehngcad].hcif=hcif;
                                // if(!m.cardnolist[m.hcehngcad].hcif){
                                //     delete m.cardnolist[m.hcehngcad];
                                // }
                            }
        }, (err) => {
            // console.log(err);
        });
      },
      userCardfun(){//获取用户大卡
        var m=this;
        this.HTTP.userCardhttp(m.cardActivityNo).then((res) => {
           var obj=res.body;
           if(obj.code=='0000'){
                                if(obj.content.length>0){
                                    for(var i=0;i<obj.content.length;i++){
                                        obj.content[i].indexka=m.cardnolist[obj.content[i].cardNo].inde;
                                        obj.content[i].class="p"+m.cardnolist[obj.content[i].cardNo].inde;
                                    }
                                    if($('.car-large .js-carno')){
                                        $('.car-large .js-carno').css({"display":"none"})
                                    }
                                    m.carddata=obj.content;
                                     m.carno=false;
                                }else{
                                    m.carno=true;
                                }
                            }else{
                                m.carno=true;
                            };
        }, (err) => {
            m.carno=true;
        });
      },
      // 获取我的优惠券链接
      getMyCouponUrl() {
                    if ($.browser.ule) {
                        // 邮乐APP里
                        if ($.browser.android) {
                            return encodeURI('ULEMOBILE://action_ShoppingActivity#wgt.CouponList');
                        } else{
                            return encodeURI('ulemobile://uleCommon_viewname$$CouponViewController^^xib$$0^^isHideTab$$1');
                        }
                    } else if ($.browser.uxd) {
                        // 小店APP里
                        if ($.browser.android) {
                            return encodeURI('ulemobile://action&&ui.MyCouponActivity##fragment::1**flag::0**title::优惠券**needTitle::true');
                        } else{
                            return encodeURI('ulemobile://action&&US_CouponVC&hasxib|0');
                        }
                    } else {
                        // 其他场景
                        return '//m.ule.com/muser/coupon/list';
                    }
    },
    // 获取卡片 
    getka(){
        var m=this;
        var dataTime = new Date();
        if(m.firstClickTimes==""||dataTime-m.firstClickTimes>=2000){
            m.firstClickTimes=dataTime;
            this.HTTP.lottryhttp(m.activityCode).then((res) => {
                m.kabox=true;
                if(res.body.code=='0000'){
                m.hchengkadaka=false;
                m.ifprizekapiandata=false;
                var kadata=res.body.content.prizeInfos[0];
                console.log(kadata);
                 kadata.indexpk=m.cardnolist[kadata.pcBatchId].inde;
                 kadata.class="p"+m.cardnolist[kadata.pcBatchId].inde;
                m.prizekapiandata=kadata;
                 m.cardsnum();//获取用户卡片数量是否合成
                 m.userCardfun();//获取用户大卡
             }else{
                m.ifprizekapiandata=true;
             }
                m.takeBoxfun();//查询用户抽卡次数
            }, (err) => {
                m.kabox=true;
                m.ifprizekapiandata=true;
            });
        }
    
    },
    // 合成卡片
    hccombine(){
        var m=this;
        this.HTTP.combinehttp(m.cardActivityNo,m.ruleCode).then((res) => {
           
              if(res.body){
                                console.log(res.body);
                                if(res.body.code=='0000'){
                                    m.hchengkadaka=true;
                                    m.kabox=true;
                                    m.ifprizekapiandata=false;
                                    m.prizekapiandata.pcBatchId=res.body.content[0].cardNo;
                                    m.prizekapiandata.indexpk=m.cardnolist[res.body.content[0].cardNo].inde;
                                    m.prizekapiandata.class='p'+m.cardnolist[res.body.content[0].cardNo].inde;
                                    m.cardsnum();//获取用户卡片数量是否合成
                                    m.userCardfun();//获取用户大卡
                                }
                            }
    
        }, (err) => {
            console.log(err);
        });
    },
    // 翻卡抽奖
    takeBox(activityCode,channelka){
        var m=this;
        this.HTTP.turnOverTheCardhttp(m.cardActivityNo,activityCode,channelka).then((res) => {
            console.log(res)
            m.awardbox=true;
           if(res.body){
                m.kabox=false;
                if(res.body.code=='0000'){
                    m.saletanpgno=false;
                    //成功调取
                    var prizeInfos=res.body.content.prizeInfos[0];
                    if(prizeInfos.prizeType=='40600'||prizeInfos.prizeType=='50502'||prizeInfos.prizeType=='40200'||prizeInfos.prizeType=='40300'){
                        m.jianglianj=true;
                    }else {
                        m.jianglianj=false;
                    }
                    m.jiangliadata=prizeInfos;
                    m.userCardfun();//获取用户大卡
                }else{
                    m.saletanpgno=true;
                }
            }else {
                m.saletanpgno=true;
            }

        }, (err) => {
            m.saletanpgno=true;
        });
    },
    shouxiaokapicha(nu){
                    var m=this;
                    if(nu==1){
                        m.kabox=false;
                    }else {
                        m.awardbox=false;
                    }
    },
    },
    components:{
      participate,
      rules,
      strategy,
      speed,
      Carddisplay,
      kalayer,
      rewardlayer,
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .swiper-inner {
    width: 100%;
    height: 400px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
    height: 300px;
  }
.app{
   background:#f4244b;
    height: auto;
}
html body {
    background:#f4244b;
    height: auto;
}
header {
    display: block;
    width: 100%;
    position: relative;
    overflow: hidden;
}
header img {
    display: block;
    float: left;
    width: 100%;
    margin-top: -1px;
}
.card-box{
    display: block;
    width: 100%;
    padding-top: .24rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/index.vue